/**
 * @file   src\mobile\components\messageMenu.js
 * @brief  This file is responsible for showing message menu
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import { getCurrentPath } from "../../helpers/common";
import { useNavigate } from "react-router-dom";
import { pageURLs } from "../../constants/v2/pageURLs";

const MessageMenu = (props) => {
  const { handleNavigation, unReadChatMessagesCount } = props;
  const currentLocation = getCurrentPath();
  const navigate = useNavigate();
  return (
    <a
      href={void 0}
      role="button"
      className={
        currentLocation == "/mobile/messages"
          ? "text-center select"
          : "text-center "
      }
      onClick={() => navigate(pageURLs.mobileMessages)}
    >
      {unReadChatMessagesCount > 0 && (
        <div className="message-notification">{unReadChatMessagesCount}</div>
      )}
      
    </a>
  );
};

export default MessageMenu;
